/**
 * @module geo/payload/facade/services
 */
import {FeatureTransactionOperation} from '../../../types/feature.transaction.operation';
import {KindService} from '../../../types/services/kind.service';

import {SERVICE_CALL_REST, ServiceCallRestParameters} from './SERVICE_CALL_REST';


/**
 * Action to reset current features on one or more layers
 * @since v 2.0.2
 */
export class SERVICE_FEATURE_TRANSACTION extends SERVICE_CALL_REST {

  parameters:Partial<ServiceFeatureTransactionParameters>;


  public kindService: KindService = KindService.FEATURE_TRANSACTION;

  /**
   * @param options object with properties values
   */
  constructor(options: Partial<SERVICE_FEATURE_TRANSACTION>) {
    super(options);
    if(options.parameters){
      this.parameters=new ServiceFeatureTransactionParameters(options.parameters);
    
    }else{
      throw new Error('undefined parameters for call rest service');
    }

  }
}
export class ServiceFeatureTransactionParameters extends ServiceCallRestParameters{
  public readonly  method='post';
  public readonly  sendAsJson=true;
  public readonly  url='/featureModification/transaction';;
  /**
   * datas to send to server
   */
  public data?: FeatureTransactionOperation[];

  public constructor(options:Partial<ServiceFeatureTransactionParameters>){
    super(options);

  }
}